var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { DialogActions } from '@mui/material';
import { PickersDay } from '@mui/x-date-pickers';
import { useLocaleText } from '@mui/x-date-pickers/internals/hooks/useUtils';
import clsx from 'clsx';
import React, { forwardRef, useCallback } from 'react';
import Button from '../Button';
/**
 * Button that is used to switch between months in the calendar.
 */
export var IconButton = forwardRef(function (props, ref) {
    var children = props.children, edge = props.edge, className = props.className, otherProps = __rest(props, ["children", "edge", "className"]);
    return (React.createElement(Button, __assign({ ref: ref, className: className + ' YDSIconButtonEdge-' + edge }, otherProps, { icon: true, color: "tertiary" }), children));
});
IconButton.displayName = 'IconButton';
/**
 * Button switch between calendar views (year, month, day).
 */
export var SwitchViewButton = function (props) {
    // In slot definition we do not pull ownerState from props, so it will go to the component.
    // We can't pass ownerState prop to a button, it will result in an error
    var ownerState = props.ownerState, restProps = __rest(props, ["ownerState"]);
    return React.createElement(Button, __assign({}, restProps, { color: "tertiary" }));
};
//https://github.com/mui/mui-x/blob/a51c651b0420b7c84a04607b56ae596f60ce2320/packages/x-date-pickers/src/PickersActionBar/PickersActionBar.tsx#L9
/**
 * Part of the picker that contains action buttons. We need this to use yds buttons instead of mui buttons. Also we can change order of buttons here.
 */
export var CustomActionBar = function (_a) {
    var _b;
    var onAccept = _a.onAccept, onClear = _a.onClear, onCancel = _a.onCancel, onSetToday = _a.onSetToday, actions = _a.actions, other = __rest(_a, ["onAccept", "onClear", "onCancel", "onSetToday", "actions"]);
    var localeText = useLocaleText();
    var sortActions = useCallback(function (actionsArray) {
        var copyActions = __spreadArray([], actionsArray, true);
        // This order is defined by UX. Clear or cancel are pushed to the left.
        var correctOrder = ['today', 'clear', 'accept', 'cancel'];
        var sortedWords = [];
        for (var _i = 0, correctOrder_1 = correctOrder; _i < correctOrder_1.length; _i++) {
            var word = correctOrder_1[_i];
            var index = copyActions.indexOf(word);
            if (index !== -1) {
                sortedWords.push(copyActions.splice(index, 1)[0]);
            }
        }
        return sortedWords;
    }, []);
    if (actions == null || actions.length === 0) {
        return null;
    }
    // Sort actions to assure unified order in UI (today - clear - cancel - accept)
    var buttons = (_b = sortActions(actions)) === null || _b === void 0 ? void 0 : _b.map(function (actionType) {
        switch (actionType) {
            case 'clear':
                return (React.createElement(Button, { onClick: onClear, key: actionType, color: "tertiary", sx: { marginRight: 'auto' } }, localeText.clearButtonLabel));
            case 'cancel':
                return (React.createElement(Button, { onClick: onCancel, key: actionType, color: "tertiary" }, localeText.cancelButtonLabel));
            case 'accept':
                return (React.createElement(Button, { onClick: onAccept, key: actionType }, localeText.okButtonLabel));
            case 'today':
                return (React.createElement(Button, { onClick: onSetToday, key: actionType, color: "tertiary", sx: { marginRight: 'auto' } }, localeText.todayButtonLabel));
            default:
                return null;
        }
    });
    return React.createElement(DialogActions, __assign({}, other), buttons);
};
export var DayRenderer = function (_a) {
    var isHighlighted = _a.isHighlighted, props = __rest(_a, ["isHighlighted"]);
    var shouldHighlight = isHighlighted === null || isHighlighted === void 0 ? void 0 : isHighlighted(props.day);
    return (React.createElement(PickersDay, __assign({}, props, { className: clsx(props === null || props === void 0 ? void 0 : props.className, shouldHighlight && 'MuiPickersDay-dayHighlighted') })));
};
